import { DisciplinaCertificacaoVinculada } from 'src/paginas/parceiro-certificacao/cursos/cadastro/tipos'

export enum ModalidadeCursoCertificacao {
  Presencial = 'Presencial',
  Online = 'Online',
  Hibrido = 'Hibrido'
}

export enum AreaCursoCertificacao {
  ProgramasBasicos = 'ProgramasBasicos',
  Educacao = 'Educacao',
  ArtesHumanidades = 'ArtesHumanidades',
  CienciasSociaisComunicacaoInformacao = 'CienciasSociaisComunicacaoInformacao',
  NegociosAdministracaoDireito = 'NegociosAdministracaoDireito',
  CienciasNaturaisMatematicaEstatistica = 'CienciasNaturaisMatematicaEstatistica',
  ComputacaoTecnologiasInformacaoComunicacao = 'ComputacaoTecnologiasInformacaoComunicacao',
  EngenhariaProducaoConstrucao = 'EngenhariaProducaoConstrucao',
  AgriculturaSivilculturaPescaVeterinaria = 'AgriculturaSivilculturaPescaVeterinaria',
  SaudeBemEstar = 'SaudeBemEstar',
  Servicos = 'Servicos'
}

export enum TitulacaoCoordenadorCursoCertificacao {
  Doutorado = 'Doutorado',
  Especializacao = 'Especializacao',
  Mestrado = 'Mestrado'
}

export enum DivisaoCursoCertificacao {
  Modulo = 'Modulo',
  Disciplina = 'Disciplina'
}

export interface ModuloCursoCertificacao {
  id: string
  nome: string
  ordem: number
  disciplinasMCertificacao: DisciplinaCertificacaoVinculada[]
}

export interface DisciplinaCursoCertificacao {
  id: string
  nome: string
  cargaHoraria: number
  deletado: boolean
  professorDisciplinasCertificacao?: {
    idProfessor: string
    nomeProfessor: string
    disciplinaCertificacaoId: string | null
    disciplinaModuloCertificacaoId: string | null
    nomeDisciplina: string
  }[]
  professorDisciplinasModuloCertificacao?: {
    idProfessor: string
    nomeProfessor: string
    disciplinaCertificacaoId: string | null
    disciplinaModuloCertificacaoId: string | null
    nomeDisciplina: string
  }[]
}
